export const path = "https://grewbig.com";
// export const path = "http://localhost:3000";
